"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateUploadTemporaryId = useUpdateUploadTemporaryId;
const useEventListener_1 = __importDefault(require("hooks/useEventListener"));
const uuid_1 = require("uuid");
const club_files_ui_1 = require("@hotmart/club-files-ui");
function useUpdateUploadTemporaryId() {
    (0, useEventListener_1.default)('app-content-admin:upload:update-temporary-id', (event) => {
        var _a, _b;
        (0, club_files_ui_1.uploadNotifySave)((_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : (0, uuid_1.v4)());
    });
}
